import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface CreateDigestReportInterface {
  slug: string;
}

export const createDigestReport = async ({ slug }: CreateDigestReportInterface) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.post(
    `/objects/${slug}/technician-digests/generate/`,
    {},
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data.data as any;
};
